import PropTypes from "prop-types"
import Loading from "./Loading"
import Highlight from "./Highlight"

const HighlightData = ({ data, loading }) =>
  loading ? (
    <div>
      <Loading className={"spinner-small"} />
    </div>
  ) : (
    <Highlight> {JSON.stringify(data, null, 2)} </Highlight>
  )

HighlightData.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.object
}

export default HighlightData
